import React from "react";
import { homeObjThree } from "./Data";
import { InfoSection } from "../../components";

const SignUp = () => {
  return (
    <>
      <InfoSection {...homeObjThree} />
    </>
  );
};

export default SignUp;
